import React from "react";
import Header from "./../Common/Header";
import Footer from "./../Common/Footer";
import ProfileDetail from "./../Elements/ProfileDetail";

class Profile extends React.Component {
  componentDidMount() {
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        script.src = src;
        script.addEventListener("load", function () {
          resolve();
        });
        script.addEventListener("error", function (e) {
          reject(e);
        });
        document.body.appendChild(script);
        document.body.removeChild(script);
      });
    }

    loadScript("./assets/js/custom.js");
  }
  render() {
    return (
      <>
        <Header />
        <div className="">
          <ProfileDetail />
          {/* <Banner title={this.props.title} pagename={this.props.pagename} description="The essence of interior design will always be about people and how they live. It is about the realities of what makes for an attractive, civilized." bgimage={bnrimg}/>
                    <About2 />
                    <WhatWeDo6 />
                    <Achievements1 />
                    <Team />
                    <Testimonials2 separatoralignment="separator-center" /> */}
        </div>

        <Footer />
      </>
    );
  }
}

export default Profile;
